import React, {Component} from "react"
import PropTypes from "prop-types"
import {Route} from "react-router"

import {NestedRoute} from "@irati/utils/history/routing"
import {LangLoader} from "@irati/utils/lang"

import {INSIGHTS} from "@irati-web/app/src/routeConfig"
import {AnonymousContainer} from "./layout"
import {UserSurvey} from "./pages"

export default class extends Component {
  static propTypes = {
    path: PropTypes.string.isRequired
  };

  render() {
    const {path} = this.props

    return (
      <Route
        path={path}
        render={() =>
          <LangLoader bucket={INSIGHTS}>
            <AnonymousContainer>
              <NestedRoute noauth match={path} path="/:surveyId?" component={UserSurvey} />
            </AnonymousContainer>
          </LangLoader>
        } />
    )
  }
}
